// Entry point for esbuild bundling
import "@hotwired/turbo-rails"
import { Turbo } from "@hotwired/turbo-rails"
import "./controllers"

import "trix"
import "@rails/actiontext"
import "./channels"

Turbo.config.drive.progressBarDelay = 100 // Show progress bar after 100ms (default is 500ms)

// Update dock active states on Turbo navigation (dock is data-turbo-permanent)
function dockPathMatches(currentPath, dockPath) {
  if (!dockPath) return false
  if (dockPath.endsWith('$')) return currentPath === dockPath.slice(0, -1)
  return currentPath === dockPath || (dockPath !== '/' && currentPath.startsWith(dockPath))
}

function updateDockActive() {
  const path = window.location.pathname
  document.querySelectorAll('#app-dock .dock-item').forEach(item => {
    const paths = (item.dataset.dockPath || '').split(',').map(p => p.trim()).filter(Boolean)
    const isActive = paths.some(p => dockPathMatches(path, p))
    item.classList.toggle('dock-active', isActive)
  })
}
document.addEventListener('turbo:load', updateDockActive)
document.addEventListener('turbo:render', updateDockActive)

// No hover prefetch: Turbo's is off (meta turbo-prefetch=false) and the
// <link rel=prefetch> injector that lived here is gone. Both fetched pages a
// visitor never opened, and the server counted each fetch as a page view.

// Auto-scroll past discovery zone on pages that opt in
function scrollPastDiscovery() {
  const trigger = document.getElementById('scroll-past-trigger')
  if (!trigger) return
  const target = document.getElementById(trigger.dataset.scrollTarget)
  if (!target) return
  const navH = 56
  // Position the "More above" pill right at the top, just under the navbar
  const top = target.offsetTop - navH
  setTimeout(() => {
    window.scrollTo({ top: Math.max(0, top), behavior: 'instant' })
  }, 50)
}
document.addEventListener('turbo:load', scrollPastDiscovery)
document.addEventListener('DOMContentLoaded', scrollPastDiscovery)
